import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export function CookieBanner() {
  const { showBanner, setShowBanner, acceptAll, rejectAll, setShowPreferences } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t shadow-lg">
      <div className="container mx-auto p-4 md:p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1 flex items-start gap-3">
            <Cookie className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-1">Cookie Preferences</h3>
              <p className="text-sm text-muted-foreground">
                We use cookies to enhance your browsing experience and analyze our traffic. 
                You can choose to accept personalized ads (tailored to you) or see contextual, non-personalized ads. 
                By clicking "Accept All", you consent to our use of cookies including personalized advertising.{' '}
                <Link to="/privacy-policy" className="underline hover:text-foreground">
                  Privacy Policy
                </Link>
                {' · '}
                <Link to="/cookie-policy" className="underline hover:text-foreground">
                  Cookie Policy
                </Link>
              </p>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                setShowBanner(false);
                setShowPreferences(true);
              }}
              className="flex-1 md:flex-none"
            >
              Customize
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={rejectAll}
              className="flex-1 md:flex-none"
            >
              Reject All
            </Button>
            <Button
              size="sm"
              onClick={acceptAll}
              className="flex-1 md:flex-none"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
